import axios from './common';

const state = {
    courseCurrencies: [
        'gbp',
        'eur',
        'usd',
        'aud',
    ],
    courses: [],
    coursesQueryParams: {
        description: null,
        limit: 10,
        page: 1,
    },
    currentCourseItem: null,
    editableCourseItem: null,
    coursesLoading: false,
    categoryItemLoading: false,
    courseApiError: null,
    totalCourses: 0,
};

const getters = {
    courseCurrencies: state => {
        return state.courseCurrencies;
    },
    courses: state => {
        return state.courses;
    },
    coursesQueryParams: state => {
        return state.coursesQueryParams;
    },
    coursesLoading: state => {
        return state.coursesLoading;
    },
    currentCourseItem: state => {
        return state.currentCourseItem;
    },
    editableCourseItem: state => {
        return state.editableCourseItem;
    },
    courseItemLoading: state => {
        return state.courseItemLoading;
    },
    courseApiError: state => {
        return state.courseApiError;
    },
    totalCourses: state => {
        return state.totalCourses;
    },
};

const actions = {
    getCourses(context) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: 'Loading Courses',
        }, {root: true}).then(() => context.commit('setCoursesLoading', true));

        axios.get(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/courses/`, {
            params: context.state.coursesQueryParams,
        })
            .then(response => {
                context.dispatch('addNotification', {
                    status: 'success',
                    message: 'Courses successfully loaded',
                }, {root: true}).then(function() {
                    context.commit('setCoursesLoading', false);
                    context.commit('setCourses', response.data);
                });
            });
    },
    async deleteCourse(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Deleting Course "${item.name}"`,
        }, {root: true}).then(() => context.commit('setCourseItemLoading', true));

        try {
            await axios.delete(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/courses/${item._id}`);
            await context.dispatch('addNotification', {
                status: 'success',
                message: `Successfully deleted Course "${item.name}"`,
            }, {root: true});
            return true;
        } catch(error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Course "${item.name}" was deleted and no longer exists`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Delete failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    context.commit('setCourseApiError', error);
                    console.error('courseApiError', error);
                });
            }
            return false;
        } finally {
            context.commit('setCourseItemLoading', false);
            await context.dispatch('clearCourseItems');
            await context.dispatch('getCourses');
        }
    },
    async getCourse(context, item) {
        context.dispatch('addNotification', {
            status: 'loading',
            message: `Retrieving Course "${item.name}"`,
        }, {root: true}).then(function () {
            context.commit('setCourseItemLoading', true);
            context.commit('setCourseApiError', null);
        });

        try {
            const response = await axios.get(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/courses/${item._id}`);
            context.commit('setCurrentCourseItem', response.data);
        } catch (error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Course "${item.name}" deleted and no longer exists`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Retrieval failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    console.error('courseApiError', error);
                });
            }
        } finally {
            context.commit('setCourseItemLoading', false);
        }
    },
    async editCourse(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Editing Course "${item.name}"`,
        }, {root: true}).then(function() {
            context.commit('setCourseItemLoading', true);
            context.commit('setCourseApiError', null);
        });

        try {
            await axios.put(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/courses/${item._id}`, item);

            await context.dispatch('addNotification', {
                status: 'success',
                message: `Course "${item.name}" successfully edited `,
            }, {root: true});

            return true;

        } catch (error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Course "${item.name}" was deleted and no longer exists`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Edit failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    context.commit('courseApiError', error);
                    console.error('courseApiError', error);
                });
            }

            return false;
        } finally {
            context.commit('setCourseItemLoading', false);
            await context.dispatch('clearCourseItems');
            await context.dispatch('getCourses');
        }
    },
    async addCourse(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Adding Course "${item.name}"`,
        }, {root: true}).then(function () {
            context.commit('setCourseItemLoading', true);
            context.commit('setCourseApiError', null);
        });

        try {

            await axios.post(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/courses/`, item);

            await context.dispatch('addNotification', {
                status: 'success',
                message: `Course "${item.name}" successfully added`,
            }, {root: true});

            return true;

        } catch (error) {
            if (error.response) {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Failed to add Course "${item.name}", please try again`,
                }, {root: true}).then(() => {
                    context.commit('setCourseApiError', error.response.data);
                });
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Add failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    context.commit('setCourseApiError', error);
                });
            }

            return false;
        } finally {
            context.commit('setCourseItemLoading', false);
            await context.dispatch('getCourses');
        }
    },
    clearCourseItems(context) {
        context.commit('setCurrentCourseItem', null);
        context.commit('setEditableCourseItem', null);
    },
    clearCourseApiError(context) {
        context.commit('setCourseApiError', null);
    },
    setCoursePaginationOptions(context, options) {
        context.commit('coursePaginationOptions', options);
    },
    setCoursesSearch(context, search) {
        context.commit('coursesSearch', search);
    },
};

const mutations = {
    coursePaginationOptions(state, options) {
        state.coursesQueryParams.limit = options.itemsPerPage ?? 10;
        state.coursesQueryParams.page = options.page ?? 1;
    },
    coursesSearch(state, search) {
        state.coursesQueryParams.description = `/${search.trim()}/i`;
    },
    setCourses(state, responseData) {
        state.courses = responseData.docs;
        state.totalCourses = responseData.totalDocs;
    },
    setCurrentCourseItem(state, item) {
        state.currentCourseItem = item;
        state.editableCourseItem = {...item};
    },
    setEditableCourseItem(state, item) {
        state.editableCourseItem = item;
    },
    setCourseItemLoading(state, isLoading) {
        state.courseItemLoading = isLoading;
    },
    setCoursesLoading(state, isLoading) {
        state.coursesLoading = isLoading;
    },
    setCourseApiError(state, error) {
        state.courseApiError = error;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
